import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
/** Converte mm → cm mantendo precisão e formatação BR */
export function mmToCm(mm) {
    return Math.round((mm / 10) * 10) / 10;
}
/** Formata altura em cm com 1 casa decimal e sufixo */
export function formatHeightCm(mm) {
    return `${mmToCm(mm).toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} cm`;
}
/** Formata largura/comprimento em cm sem decimais */
export function formatDimensionCm(mm) {
    return `${Math.round(mm / 10)} cm`;
}
/** Clamp genérico */
export function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
